import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { showAlert } from "../../utils/Alert";
import { useEffect, useState } from "react";

const Timer = ({
  bgBlack = true,
  label = "Tiempo restante",
  endTime = 10,
  onFinishTimer = null,
}) => {
  const [end, setEnd] = useState(null);
  const [timer, setTimer] = useState("00:00:00");

  useEffect(() => {
    let end = Date.now() + endTime * 60000;
    setEnd(end);
  }, [endTime]);

  useEffect(() => {
    let interval = null;
    if (end) {
      let start = Date.now();
      let resDate = (end - start + 1000) / 1000;

      if (resDate > 1) {
        interval = setInterval(() => {
          counterStart(interval, end);
        }, 1000);
      } else {
        setTimer("00:00:00");
      }
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [end]);

  const counterStart = (interval, end) => {
    const start = Date.now();
    const resDate = (end - start + 1000) / 1000;
    if (resDate > 1) {
      let seconds = `${Math.floor(resDate % 60)}`.padStart(2, 0);
      let minutes = `${Math.floor((resDate / 60) % 60)}`.padStart(2, 0);
      let hours = `${Math.floor((resDate / (60 * 60)) % 24)}`.padStart(2, 0);
      setTimer(`${hours}:${minutes}:${seconds}`);
    } else if (interval) {
      clearInterval(interval);
      setTimer("00:00:00");
      if (onFinishTimer) {
        onFinishTimer()
      }
    }
  };

  return (
    <Box
      className="timer"
      sx={{
        backgroundColor: bgBlack ? "black" : "primary.main",
        color: "white",
        border: "2px solid white",
        borderRadius: "8px",
        padding: "8px",
        minWidth: "50px",
        textAlign: "center",
        fontWeight: "bold",
        display: "flex",
        flexDirection: "column",
        fontFamily: "var(--bold)",
        fontSize: "18px",
      }}
    >
      <Typography className="timer-label" variant="inherit" component="span">
        {label}:
      </Typography>
      <Typography className="timer-value" variant="inherit" component="span">
        {timer}
      </Typography>
    </Box>
  );
};

Timer.propTypes = {
  bgBlack: PropTypes.bool,
  label: PropTypes.string,
  endTime: PropTypes.number,
  onFinishTimer: PropTypes.func,
};

export default Timer;
